import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import "react-data-table-component-extensions/dist/index.css";
import { useLocation } from 'react-router-dom';
//import parse from 'html-react-parser';

//import Select from 'react-select';

import { api_crud_route, api_crud_base, data_interface, /*endpoints*/ } from './Config';

import { reqGET, reqPOST, reqPUT, reqDELETE, repo_icons_link } from '../../Utils';
import { getTokenInfo } from '../../UseToken';
import UseSidebar from '../../UseSidebar';

import Loader from '../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';
//import x from "uniqid";

export default function List(){

    const [, set_dados] = useState(null);
	const dados = useRef(null);

    const [data_from, set_data_from] = useState([])
    const [data_to, set_data_to] = useState([])
    const [isloading, setLoading] = useState(true)

    const [entidades, set_entidades] = useState([]);

    const [modal_entity_id, set_modal_entity_id] = useState('')
    const [modal_entity_to_name, set_modal_entity_to_name] = useState('')
    const [modal_entity_from_name, set_modal_entity_from_name] = useState('')
    const [modal_subject, set_modal_subject] = useState('')
    const [modal_message, set_modal_message] = useState('')

	const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])
    const [/*permissions*/, set_permissions] = useState({})

	const [refresh, setRefresh] = useState(0);

    const get_entidades = async () => {
        await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/trainee_user`)
			.then(async res => {

				let aux = []
				res.data.forEach(el => {
					aux.push({id: el.id, name: el.name, surname: el.surname, profile: el.profile})
				})

                await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/trainer_user`)
                    .then(res => {
                        

                        res.data.forEach(el => {
                            aux.push({id: el.id, name: el.name, surname: el.surname, profile: el.profile})
                        })
                        
                        set_entidades(aux)
                        
                    })
                    .catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
    }

    let get_permissions = (e, sidebar) => {
        let handleSingleCheck = (e, sidebar) => {
            const name = e;

            let ver_submenu = (node) => {
                if (node.submenu.length !== 0) {

                    node.submenu.forEach(subitem => {

                        if (subitem.path === name) {
                            set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                        }
                        else {
                            ver_submenu(subitem)
                        }

                    })
                }
            }

            sidebar.forEach(node => {
                if(node.path === name && 0) {
                    set_permissions({ edit: node.edit, view: true, remove: node.remove })
                } else
                    ver_submenu(node)
            })
        }

        handleSingleCheck(e, sidebar)
    }

    let fetchApi = async () => {
        set_lang(localStorage.getItem('lang'))

        await reqGET(`${api_crud_route}/from/${getTokenInfo().companycode}/${getTokenInfo().id}`)
            .then(res => {

                set_data_from(res.data)
                setLoading(false)

            })
            .catch(() => 404
                //  TODO: ENVIAR PÁGINA 404
                //alert(error)); 
            )

        await reqGET(`${api_crud_route}/to/${getTokenInfo().companycode}/${getTokenInfo().id}`)
            .then(res => {

                set_data_to(res.data)
                setLoading(false)

                /* console.log('LIDAAAA?', data_to) */
            })
            .catch(() => 404
                //  TODO: ENVIAR PÁGINA 404
                //alert(error)); 
            )
    }

    const clean_data = async () => {		
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		set_dados(dados.current.info.from.id = getTokenInfo().id)
		set_dados(dados.current.info.from.name = getTokenInfo().name)
	}

    useEffect(() => {
        clean_data()
        
        fetchApi() 
        
        get_entidades()

        UseSidebar().getSidebar(getTokenInfo().profile)
            .then(v => {
                get_permissions(pathname, v)
                set_sidebar(v)
                setLoading(false)
            }); 
    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: id })
					.then(() => {
                        setRefresh(refresh + 1)
						//props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})

    }

    const columns_from = [
        {
            name: language[lang].field_from,
            selector: 'from',
            
            cell: row => <div>
                {row.info.from.name}
            </div>,
            width: '20%',
            minWidth: '15% !important',
            sortable: false,
            left: true,
        },
        {
            name: language[lang].field_to,
            selector: 'to',
            cell: row => <div>
                {row.info.to.name}
            </div>,
            width: '20%',
            minWidth: '15% !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_subject,
            selector: 'subject',
            cell: row => 
            <div>
                {
                row.info['course'] !== undefined ?
                    row.info['course']['name'] + ': '
                :
                    null
                }
                {row.content[0].subject}
            </div>,
            width: '50%',
            minWidth: '30% !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_date,
            selector: 'info.date.received',
            cell: row => {
                let date = new Date(row.info.date.received); 
                
                return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            left: true,
        },
        /* {
            name: language[lang].table_date_read,
            selector: 'info.date.read',
            cell: row => {
                if(row.info.date.read !== '') {
                    let date = new Date(row.info.date.read); 
                    
                    return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
                }
                else {
                    return ''
                }
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            left: true,
        }, */
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '20%',
            minWidth: '100px !important',
            cell: row =>
                <>
                    <span 
                        className="btn btn-sm rounded-0 multi-item me-1"
                        data-bs-toggle="modal" 
                        data-bs-target={"#see_modal"}
                        onClick={() => seeMessageModal(row.id)}
                        title={language[lang].message_view}
                    >
                        <i className="bi bi-eye"></i>
                    </span>
                    <span 
                        className="btn btn-sm rounded-0 multi-item me-1"
                        data-bs-toggle="modal" 
                        data-bs-target={"#delete_modal"}
                        onClick={() => apagar(row['id'])}
                        title={language[lang].delete}
                    >
                        <i className="bi bi-trash"></i>
                    </span>
                </>
        },
    ];

    const columns_to = [
        {
            name: language[lang].field_from,
            selector: 'from',
            cell: row => 
                <div className={row.info.date.read === '' ? "fw-bold" : ""}>
                    {row.info.from.name}
                </div>,
            width: '20%',
            minWidth: '15% !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_to,
            selector: 'to',
            cell: row => <div className={row.info.date.read === '' ? "fw-bold" : ""}>{row.info.to.name}</div>,
            width: '20%',
            minWidth: '15% !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_subject,
            selector: 'subject',
            cell: row => 
            <div className={row.info.date.read === '' ? "fw-bold" : ""}>
                {
                row.info['course'] !== undefined ?
                    row.info['course']['name'] + ': '
                :
                    null
                }
                {row.content[0].subject}
            </div>,
            width: '50%',
            minWidth: '30% !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].table_date,
            selector: 'info.date.received',
            cell: row => 
            
                {
                    let date = new Date(row.info.date.received); 
 
                    return (
                        <div className={row.info.date.read === '' ? "fw-bold" : ""}>
                            {date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()}
                        </div>
                    )

                }
            
            ,
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].table_date_read,
            selector: 'info.date.read',
            cell: row => {
                if(row.info.date.read !== '') {
                    let date = new Date(row.info.date.read); 
                    
                    return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
                }
                else {
                    return ''
                }
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            left: true,
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '20%',
            minWidth: '100px !important',
            cell: row =>
                <>
                    <span 
                        className="btn btn-sm rounded-0 multi-item me-1"
                        data-bs-toggle="modal" 
                        data-bs-target={"#see_modal"}
                        onClick={() => seeMessageModal(row.id)}
                        title={language[lang].message_view}
                    >
                        <i className="bi bi-eye"></i>
                        <span className="tooltiptext d-none">{language[lang].message_view}</span>
                    </span>
                    <span 
                        className="btn btn-sm rounded-0 multi-item me-1"
                        data-bs-toggle="modal" 
                        data-bs-target={"#delete_modal"}
                        onClick={() => apagar(row['id'])}
                        title={language[lang].delete}
                    >
                        <i className="bi bi-trash"></i>
                        <span className="tooltiptext d-none">{language[lang].delete}</span>
                    </span>
                </>
        },
    ];

    const columns_entidades = [
        {
            name: language[lang].table_name,
            selector: 'name',
            cell: row => <div>{row.name} {row.surname}</div>,
            width: '50%',
            minWidth: '30% !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].profile,
            selector: 'profile',
            cell: row => <div>{language[lang][row.profile]}</div>,
            width: '30%',
            minWidth: '110px !important',
            sortable: true,
            left: true,
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '20%',
            minWidth: '100px !important',
            cell: row =>
                <>
                    <span 
                        className="btn btn-sm rounded-0 multi-item me-1"
                        data-bs-toggle="modal" 
                        data-bs-target={"#send_modal"}
                        onClick={() => sendMessageModal(row.id, row.name + ' ' + row.surname)}
                        title={language[lang].add_new}
                    >
                        <i className="bi bi-send"></i>
                    </span>
                </>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const handleSendMessage = () => {
        var today = new Date()

        dados.current.info.to.id = modal_entity_id
        dados.current.info.to.name = modal_entity_to_name

        dados.current.info.date.received = today

        dados.current.content[0].subject = modal_subject
        dados.current.content[0].message = modal_message

        if(modal_subject === '') {
            Swal.fire(language[lang].send_error + ' ' + language[lang].send_error_subject, '', 'info')
            return
        }

        if(modal_message === '') {
            Swal.fire(language[lang].send_error + ' ' + language[lang].send_error_message, '', 'info')
            return
        }

        Swal.fire({
            title: language[lang].send_title,
            text: language[lang].send_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].send_confirm,
            cancelButtonText: language[lang].send_cancel
        })
        .then((result) => {
            if(result.isConfirmed) {
                reqPOST(api_crud_route, dados.current)
                    .then(() => { 
                        Swal.fire(language[lang].send_success, '', 'info')
                        setRefresh(refresh + 1)
                    })
                    .catch(() => Swal.fire(language[lang].send_error, '', 'info'))
            }
        })

        // console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
    }

    const sendMessageModal = (id, name) => {
        console.log(id)

        set_modal_entity_id(id)
        set_modal_entity_to_name(name)

        set_modal_subject('')
        set_modal_message('')

    }

    const seeMessageModal = (id) => {
        let aux = []
        let aux_to = []
        aux = data_from.filter(el => el.id === id)
        aux_to = data_to.filter(el => el.id === id)
        if(aux.length > 0) {
            set_modal_entity_id(id)
            set_modal_entity_from_name(aux[0].info.from.name)
            set_modal_entity_to_name(aux[0].info.to.name)
    
            if(aux[0].info['course'] !== undefined && aux[0].info['course']['name'] !== '') {
                set_modal_subject(aux[0].info['course']['name'] + ': ' + aux[0].content[0].subject)
            }
            else {
                set_modal_subject(aux[0].content[0].subject)
            }
            set_modal_message(aux[0].content[0].message)
        }
        else if(aux_to.length > 0) {
            set_modal_entity_id(id)
            set_modal_entity_from_name(aux_to[0].info.from.name)
            set_modal_entity_to_name(aux_to[0].info.to.name)
    
            if(aux_to[0].info['course'] !== undefined && aux_to[0].info['course']['name'] !== '') {
                set_modal_subject(aux_to[0].info['course']['name'] + ': ' + aux_to[0].content[0].subject)
            }
            else {
                set_modal_subject(aux_to[0].content[0].subject)
            }
            set_modal_message(aux_to[0].content[0].message)
        }
        else {
            aux = data_to.filter(el => el.id === id)
            if(aux.length > 0) {
                set_modal_entity_id(id)
                set_modal_entity_from_name(aux[0].info.from.name)
                set_modal_entity_to_name(aux[0].info.to.name)
        
                set_modal_subject(aux[0].content[0].subject)
                set_modal_message(aux[0].content[0].message)

                if(aux[0].info.date.read === '') {
                    var today = new Date()
                    aux[0].info.date.read = today
                    reqPUT(api_crud_route, aux[0])
                        .then(() => { setRefresh(refresh + 1) })
                        .catch(() => { })
                }
            }
        }
    }

    /*const custom_select_styles = {
		container: base => ({
			...base,
			borderRadius: "0px",
			width: '100%',
            padding: "0px 5px",
		}),
		control: base => ({
			...base,
			borderRadius: "0px",
			padding: "0px 5px",
			fontSize: '14px'
		}),
		menu: base => ({
			...base,
			borderRadius: "0px",
            padding: "0px 5px",
		}),
        indicatorContainer: base => ({
			...base,
            padding: "0px 5px",
        }),
	}*/

    return (isloading ?
        
        <Loader />

        :

        <main style={{backgroundColor: 'white', height: '100vh'}}>
            <div className={`dash-cards header`}>
                <h2 className="dash-title">{language[lang].content_list}</h2>
                <p>{language[lang].content} / {language[lang].content_list}</p>
            </div>

            <div className={`dash-cards body`} id="messages">
                <div className="container">

                    <div className="mb-5 mb-xl-8">
                        <div className="">
                        
                            <div className="pb-5">
                                <div className="div-table">

                                    <div className="table-header text-end my-5">
                                    </div>

                                    <div className="table-body">
                                        <div className='row'>

                                            <div className="col-12">
                                                <div className="d-flex align-items-center">
                                                    <img className="me-2" width={23} height={23} src={repo_icons_link("receber.svg")} alt={language[lang].received} title={language[lang].received} />
                                                    <h3 className="fw-bolder m-0 p-0">{language[lang].received}</h3> 
                                                </div>
                                                <DataTable
                                                    columns={columns_to}
                                                    data={data_to}
                                                    noDataComponent={language[lang].table_empty}
                                                    noHeader
                                                    pagination
                                                    exportHeaders
                                                    paginationComponentOptions={defaultComponentOptions}
                                                    paginationPerPage={12}
                                                    paginationRowsPerPageOptions={[12, 25, 50, 100]}

                                                    /* style={{fontWeight: '700'}} */
                                                />

                                                <div className="d-flex align-items-center mt-3">
                                                    <img className="me-2" width={20} height={20} src={repo_icons_link("enviados.svg")} alt={language[lang].sent} title={language[lang].sent} />
                                                    <h3 className="fw-bolder m-0 p-0">{language[lang].sent}</h3> 
                                                </div>
                                                <DataTable
                                                    columns={columns_from}
                                                    data={data_from}
                                                    noDataComponent={language[lang].table_empty}
                                                    noHeader
                                                    pagination
                                                    exportHeaders
                                                    paginationComponentOptions={defaultComponentOptions}
                                                    paginationPerPage={12}
                                                    paginationRowsPerPageOptions={[12, 25, 50, 100]}
                                                />
                                            </div>

                                            {
                                            false ?
                                                <div className="col-4">
                                                    <div className="d-flex align-items-center">
                                                        <img className="me-2"  width={20} height={20} src={repo_icons_link("mensagens.svg")} alt={language[lang].contacts} title={language[lang].contacts} />
                                                        <h3 className="fw-bolder m-0 p-0">{language[lang].contacts}</h3> 
                                                    </div>                                                
                                                    <DataTable
                                                        columns={columns_entidades}
                                                        data={entidades}
                                                        noDataComponent={language[lang].table_empty}
                                                        noHeader
                                                        pagination
                                                        exportHeaders
                                                        paginationComponentOptions={defaultComponentOptions}
                                                        paginationPerPage={12}
                                                        paginationRowsPerPageOptions={[12, 25, 50, 100]}
                                                    />
                                                </div>
                                            :
                                                null
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal bg-light fade" tabIndex="-1" id={"send_modal"}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{language[lang].messages_new}</h5>
                                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                                        <i className="bi bi-x fs-2"></i>
                                    </div>
                                </div>

                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <label className="col-form-label fw-bold fs-6 me-2">{language[lang].field_to}: </label>
                                            {modal_entity_to_name}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <label className="col-form-label fw-bold fs-6">{language[lang].field_subject}</label>
                                            <input type="text" className="form-control mb-3" name="subject" value={modal_subject} placeholder={language[lang].field_subject_placeholder} onChange={(e) => set_modal_subject(e.target.value)}  />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <label className="col-form-label fw-bold fs-6">{language[lang].field_message}</label>
                                            <textarea type="text" className="form-control mb-3" name="subject" value={modal_message} placeholder={language[lang].field_subject_placeholder} onChange={(e) => set_modal_message(e.target.value)}  />
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-light d-none" data-bs-dismiss="modal">{language[lang].close}</button>
                                    <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleSendMessage}>{language[lang].send}</button>
                                </div>
                            </div>
                        </div>
                    </div> 

                    <div className="modal bg-light fade" tabIndex="-1" id={"see_modal"}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{language[lang].message}</h5>

                                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                                        <i className="bi bi-x fs-2"></i>
                                    </div>
                                </div>

                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <label className="col-form-label fw-bold fs-6 me-2">{language[lang].field_from}: </label>
                                            {modal_entity_from_name}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <label className="col-form-label fw-bold fs-6 me-2">{language[lang].field_to}: </label>
                                            {modal_entity_to_name}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <label className="col-form-label fw-bold fs-6 me-2">{language[lang].field_subject}: </label>
                                            {modal_subject}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <label className="col-form-label fw-bold fs-6">{language[lang].field_message}</label>
                                            <p>{modal_message}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-footer d-none">
                                    <button type="button" className="btn btn-light" data-bs-dismiss="modal">{language[lang].close}</button>
                                    <button type="button" className="btn btn-primary d-none" data-bs-dismiss="modal" onClick={handleSendMessage}>{language[lang].send}</button>
                                </div>
                            </div>
                        </div>
                    </div> 
                    
                </div>
            </div>
        </main>
    )
}